import { html5 } from "./html5.js";
import { pico } from "./pico.js";
import { bootstrap } from "./bootstrap.js";
import { bulma } from "./bulma.js";
import { slugify } from "./schema.js";

export const BUILT_IN_PROFILES = [html5, pico, bootstrap, bulma];

export function findBuiltIn(id) {
  return BUILT_IN_PROFILES.find((profile) => profile.id === id);
}

export function uniqueId(base, taken) {
  let id = base;
  for (let n = 2; taken.has(id); n++) id = `${base}-${n}`;
  return id;
}

// takenNames holds lower-case names of existing custom profiles.
export function forkProfile(profile, takenIds, takenNames = new Set()) {
  let name = `${profile.name} (custom)`;
  for (let n = 2; takenNames.has(name.toLowerCase()); n++) name = `${profile.name} (custom ${n})`;
  return {
    ...structuredClone(profile),
    id: uniqueId(slugify(name), takenIds),
    name,
    builtIn: false,
    basedOn: profile.basedOn || profile.id,
  };
}

export function createProfile(name, startFrom, takenIds) {
  const source = findBuiltIn(startFrom);
  const template = structuredClone(source ?? html5);
  return {
    ...template,
    id: uniqueId(slugify(name), takenIds),
    name,
    builtIn: false,
    basedOn: source ? source.id : "",
    description: source ? template.description : "",
    css: source ? template.css : [],
    exportCss: source ? template.exportCss : [],
    extraCss: source ? template.extraCss : "",
    wrapper: source ? template.wrapper : "",
    exportWrapper: source ? template.exportWrapper : "",
    rules: source ? template.rules : [],
  };
}
